var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayReviewers)?_c('div',{staticClass:"d-flex align-items-center"},[_vm._v(" "+_vm._s(_vm.reviewersMessage)+" "),_c('people-profile-pics',{staticClass:"ml-3",attrs:{"people":_vm.reviewersProfilePicsModel}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }